import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/vipImg/vip-special-qrcode.png'
import _imports_1 from '@/assets/image/vipImg/vip_icon_remind.png'


const _withScopeId = n => (_pushScopeId("data-v-481c3fbc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vipCard" }
const _hoisted_2 = { class: "left-content" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "description" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createTextVNode("THE CKB（直行便）で選べる "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("法人会員プランと特典")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, "THE CKB（直行便）の法人向け料金プランを徹底比較！OEM・ODM対応、ブランド独占販売、無料サンプル提供など、ビジネス成長を後押しするサービスが充実。法人輸入ビジネスの成功を支える最適なプランを選びましょう。 ", -1))
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "description" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "title" }
const _hoisted_13 = { class: "description" }
const _hoisted_14 = {
  class: "current-level-title",
  style: {"top":"0","left":"0"}
}
const _hoisted_15 = { class: "current-level" }
const _hoisted_16 = { class: "member-time" }
const _hoisted_17 = {
  key: 1,
  class: "user-status-tip"
}
const _hoisted_18 = { class: "operate flex-end" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "member-validity flex-ter" }
const _hoisted_21 = {
  key: 0,
  class: "trialTag flex-cen-ter"
}
const _hoisted_22 = { class: "operate flex-bwn-ter" }
const _hoisted_23 = { class: "mr_5" }
const _hoisted_24 = { class: "flex-cen-ter" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_26 = {
  key: 1,
  class: "right-content-wrapper"
}
const _hoisted_27 = { class: "right-content no_login rel" }
const _hoisted_28 = { class: "current-level-title" }
const _hoisted_29 = { class: "current-level" }
const _hoisted_30 = { class: "user-status-tip" }
const _hoisted_31 = { class: "operate flex-end" }
const _hoisted_32 = {
  key: 0,
  class: "special_card"
}
const _hoisted_33 = { class: "wrapper" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "user-equity" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = {
  key: 0,
  class: "signUpNum"
}
const _hoisted_38 = {
  key: 1,
  class: "membership-btn"
}
const _hoisted_39 = { class: "price" }
const _hoisted_40 = { class: "line-price" }
const _hoisted_41 = { class: "line-price-value" }
const _hoisted_42 = { key: 2 }
const _hoisted_43 = { class: "vip-special-code" }
const _hoisted_44 = { class: "wrapper" }
const _hoisted_45 = { class: "vip-special-left" }
const _hoisted_46 = { class: "vip-special-tag" }
const _hoisted_47 = { class: "vip-special-tip" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "vip-special-right",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_49 = { class: "waring_header" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_51 = { class: "waring_tips" }
const _hoisted_52 = { class: "footer" }

import dayjs from 'dayjs'
import { t } from '@/plugins/i18n'
import UpTipsDialog from './components/UpTipsDialog.vue'
import Recommon from './components/recommon.vue'
import CommonDialog from '@/components/common/CommonDialog.vue'
import AutoPayDisabled from './components/AutoPayDisabled.vue'
import PayConfirm from './components/PayConfirm.vue'
import PayContent from './components/PayContent.vue'
import PaySuccessVue from './components/PaySuccess.vue'
import SetShop from './components/SetShop.vue'
import PayError from './components/payError.vue'
import VipHistory from './components/VipHistory.vue'
import MemberLimitedTime from '@/components/bussiness/MemberCenter/MemberLimitedTime.vue'
import MemberTabs from './components/MemberTabs.vue'
import VipEquity from './components/VipEquity.vue'
import ADialog from './ADialog.vue'
import { computed, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { getAutomaticToggleStaus, getVipCombo, automaticToggle, getPrecharegeOrderApi, isFirstPayVipApi, getVipSpecial, promotionDetail, superCustomerId } from '@/apis/usercenter'
import { useRequest } from '@/util/useLoading'
import { useRtfix, isJA, isKO, isD2C, useSite, isEN, useUser } from '@/store'
import { request } from '@/config/request/interceptors'
import { MembershipTemplatePriceListVO } from '@/service/settlement'
import { formatMoney } from '@/plugins/utils'


export default /*#__PURE__*/_defineComponent({
  props: {
  /** pro 会员邀请页 */
  isInvitatePage: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

const props = __props
const router = useRouter()
const store = useStore()

const UpTipsDialogRef = ref()
// 是否子会员
const isSub = store.getters.isSub
// 用户会员信息
const membership = store.getters.membership
// 用户信息
const userInfo = computed(() => {
  return store.getters.user
})
// 会员超时
const isOutTimeVip = ref(false)
// 是否有新会员活动
const newMemberActivity = computed(() => store.state.status.newMemberActivity)
// 是否登录
const isLogin = ref(!!store.getters.token)
/** 是否展示特殊会员逻辑 */
const isSpecial = ref(false)
// 特殊会员配置
const sepecialConfig = ref([])
// B2B显示
const sepecialRightTb = ref([])
// D2C显示
const sepecialRightTc = ref([])
// 开通会员弹窗
const openVipVisible = ref(false)
// 特殊会员信息
const specailInfo = ref()
// 邀请码
const invitationCode = ref('')
/** 特殊会员新人活动标识 */
const newSpecialMemberFlag = ref(false)
/** 特殊会员新人活动信息 */
const newSpecialMember = ref<any>({})
// 需要充值的会员信息
const vipInfo = ref()
// 支付确认弹窗
const confirmVisible = ref(false)
// 支付组件ref
const payConfirmRef = ref()
// 支付弹窗显示
const payVisible = ref(false)
// 预充会员显示
const beforehandVipInfo = ref()
// 支付成功 Ref
const paySuccessVue = ref()
// 支付成功弹窗显示
const paySuccessVisible = ref(false)
// 设置店铺弹窗显示
const setShopVisible = ref(false)
// 支付弹窗 ref
const payContentRef = ref()
// 会员套餐列表
const comboList = ref<MembershipTemplatePriceListVO[]>([])
// 支付失败弹窗
const payErrorVisible = ref(false)
// 自动续费状态
const isAuto = ref()
// 自动续费弹窗
const aDialogVisible = ref(false)
// 续费方式（续费需要）
const isPayType = ref()
// 会员开通记录
const vipHistoryVisible = ref(false)
// 不允许自动续费弹窗
const autoPayDisabledVisible = ref(false)
/**
 * 刷新页面
 */
const reload = () => location.reload()

/**
 * 复制专属会员推广链接
 */
const copySpecialLink = () => {
  const href = `${location.origin}/special/invite?channel=0&code=${invitationCode.value}`
  const aux = document.createElement('input')
  aux.setAttribute('value', href)
  document.body.appendChild(aux)
  aux.select()
  document.execCommand('copy')
  document.body.removeChild(aux)
  ElMessage.success(t('复制成功'))
}

/**
 * 获取自动续费状态
 */
const getAutoStatus = () => {
  getAutomaticToggleStaus({
    superCustomerId: membership?.superCustomerId
  }).then(res => {
    isAuto.value = res?.data?.automaticRenewalStatus
    isPayType.value = res?.data?.automaticRenewalStytle
  })
}

// 当会员没有开通资格时弹窗
const openWarinVip = () => {
  router.push(useRtfix('VipLevel'))
}

// /settlement/membership/configure/template/price/select/list
// 获取会员套餐
const [loading, getVipComboRequest] = useRequest(request.settlement.membership.configureTemplatePriceSelectList)
getVipComboRequest().then((res) => {
  comboList.value = res?.data || []
})

onMounted(() => {
  if (userInfo.value?.membership.templateLevel === 0) {
    isFirstPayVipApi({}).then((res) => {
      isOutTimeVip.value = res.data
    })
  }
  if (isLogin.value) {
    getAutoStatus()
    // 是否预充会员
    getPrecharegeOrderApi({
      superCustomerIds: membership?.superCustomerId
    }).then((res: any) => {
      console.log(res)
      beforehandVipInfo.value = res?.data[0] || {}
    })
  }
  // 特殊会员配置（有token按实际返回，没有则返回默认配置）
  getVipSpecial().then((res: any) => {
    sepecialConfig.value = res.data?.membershipTemplateConfigAndRightReqVO?.membershipTemplateConfigReqVOList || []
    sepecialRightTb.value = res.data?.membershipTemplateConfigAndRightReqVO?.membershipTemplateRightReqVOListToB || []
    sepecialRightTc.value = res.data?.membershipTemplateConfigAndRightReqVO?.membershipTemplateRightReqVOListToC || []
    console.log(res, 'getVipSpecial')

    isSpecial.value = res.data?.isShow
    specailInfo.value = res.data
    const flag = res.data.priceItemList.some((v: any) => v.trialFlag)
    newSpecialMemberFlag.value = flag
    if (flag) {
      const newMember = res.data.priceItemList.filter((v: any) => v.trialFlag)[0]
      newSpecialMember.value = newMember
    }
  })
})

/**
 * 未开通会员的情况下开通会员(只有特殊推广的情况可进入)
 */
const openVip = () => {
  if (isLogin.value) {
    if (props.isInvitatePage && !isSpecial.value) {
      openVipVisible.value = true
      return
    }
    if (isSpecial.value || props.isInvitatePage) {
      openModal(specailInfo.value)
    } else {
      // 引导日本直接开 2 会员
      openModal(isJA() ? comboList.value[1] : comboList.value[0])
    }
  } else {
    const code = router.currentRoute.value.query.code
    const inviteUrl = location.origin + '/signup?channel=0&code=' + code
    window.open(inviteUrl, '_blank')
  }
}

/**
 * 打开支付弹窗
 * @param item
 */
const openModal = (item: any) => {
  if (isSub) {
    ElMessage.warning(t('请联系主账号更改会员等级'))
    return
  }
  vipInfo.value = item
  if (userInfo.value?.membership.templateLevel > 0) {
    confirmVisible.value = true
    payConfirmRef.value.open(item)
  } else {
    // 非会员直接支付
    payContentRef.value.open({
      vipInfo: item,
      checkValue: 1
    })
    payVisible.value = true
  }
}

/**
 * 确认支付
 * @param info
 */
const submitPay = (info: any) => {
  payContentRef.value.open(info)
  confirmVisible.value = false
  payVisible.value = true
}
/**
 * 关闭支付成功弹窗
 */
const closePaySuccess = () => {
  isFirstPayVipApi({}).then((res) => {
    if (res.data) {
      // 不是第一次充值
      reload()
    } else {
      setShopVisible.value = true
    }
  })
}

/**
 * 支付成功回调
 * @param info
 */
const paySuccess = (info: any) => {
  console.log('inde', info)
  paySuccessVue.value.open(info)
  payVisible.value = false
  paySuccessVisible.value = true
}

/**
 * 支付失败回调
 */
const errorPay = () => {
  payVisible.value = false
  payErrorVisible.value = true
}

/**
 * 关闭自动续费
 */
const closeAutoPay = () => {
  automaticToggle({
    automaticRenewalStatus: 2,
    automaticRenewalStytle: isPayType.value
  }).then((res: any) => {
    if (res.success) {
      aDialogVisible.value = false
      ElMessage.success(t('关闭成功'))
      getAutoStatus()
      console.log('isPayType.value', isPayType.value)
      // 如果是paypal自动续费续费取消弹窗
      if (isPayType.value === 2) {
      }
    }
  })
}

const comboListShowList = computed(() => {
  return comboList.value.filter((i) => i.isShow)
})

// 续费商品信息
const renewInfo = computed(() => {
  let obj = {}
  comboList.value.forEach((item: any) => {
    if (item.membershipTemplateId === membership?.membershipTemplateId) {
      obj = item
    }
  })
  // 当用户为特殊用户时。需要单独取特殊会员续费列表
  if (userInfo.value.membership.specialType !== 0) {
    obj = specailInfo.value
  }
  return obj
})

// 会员 1的信息
const level1Info = computed(() => {
  return comboList.value.find(i => i.templateLevel === 2)
})

/**
 * 续费
 */
const renew = () => {
  // 针对老的 level 1 日本用户提示升仓
  if (isJA() && membership?.templateLevel === 1) {
    UpTipsDialogRef.value?.show()
  } else {
    openModal(renewInfo.value)
  }
}
/**
 * 切换续费开关
 */
const changeSwitch = () => {
  if (isAuto.value === 1) {
    openADialogVisible()
  } else {
    openAutoVisible()
  }
}

/**
 * 开启自动续费弹窗
 */
const openAutoVisible = () => {
  if (isSub) {
    ElMessage.warning(t('请联系主账号更改'))
    return
  }
  if (beforehandVipInfo.value.oldExpiresDate) {
    // 如果是预充会员提示不允许自动续费
    autoPayDisabledVisible.value = true
    return
  }
  automaticToggle({
    automaticRenewalStatus: 1,
    automaticRenewalStytle: 1 // 开启续费永远是余额续费
  }).then((res: any) => {
    if (res.success) {
      aDialogVisible.value = true
    }
  })
}

const openADialogVisible = () => {
  if (isSub) {
    ElMessage.warning(t('请联系主账号更改'))
    return
  }
  aDialogVisible.value = true
}

const user = useUser()

const { query } = useRoute()

const memberTab = ref<'person' | 'company'>(query.company ? 'company' : 'person')

const changeTab = (v: any) => {
  if (!v) {
    memberTab.value = memberTab.value === 'person' ? 'company' : 'person'
  } else {
    memberTab.value = v
  }
}

onMounted(() => {
  if (((user?.value?.membership?.templateLevel > 2) && isJA()) || (!isJA() && user?.value?.membership?.templateLevel > 1)) {
    memberTab.value = 'company'
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["container", { 'is-invitate': __props.isInvitatePage }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["header", `userLevel-${_unref(membership)?.templateLevel}`])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_unref(membership)?.templateLevel !== 5)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (memberTab.value === 'person')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('THE CKB（直行便）标准会员计划.随心采购')), 1),
                      _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('为个人到法人寻找符合需求的采购服务的最佳选择。从免费计划到免手续费的标准会员计划，提供丰富的福利以支持业务发展。')), 1)
                    ]))
                  : (_unref(isJA)())
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _hoisted_7,
                        _hoisted_8
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('THE CKB（直行便）标准会员计划.随心采购')), 1),
                        _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)('为个人到法人寻找符合需求的采购服务的最佳选择。从免费计划到免手续费的标准会员计划，提供丰富的福利以支持业务发展。')), 1)
                      ], 64))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(t)('THE CKB')) + _toDisplayString(_unref(t)('会员计划')), 1),
                _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(t)('THE CKB会员，为您的买卖生活提供一切所需。')), 1)
              ]))
        ]),
        (isLogin.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["right-content-wrapper", `right-content-${_unref(membership)?.templateLevel}`])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["right-content rel", `right-content-wrapper${_unref(membership)?.templateLevel}`])
              }, [
                _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(t)('当前等级')), 1),
                _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(membership)?.templateLevel === 0 ? (isOutTimeVip.value ? _unref(t)('已失去会员') : _unref(t)('未入会')) :
                  _unref(membership)?.membershipTemplateName), 1),
                _createElementVNode("div", _hoisted_16, [
                  (_unref(membership).templateLevel === 0 || !isLogin.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_unref(newMemberActivity) && _unref(newMemberActivity).endTime !== '2999-12-31 23:59:59')
                          ? (_openBlock(), _createBlock(MemberLimitedTime, { key: 0 }))
                          : (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_unref(t)('入会优享超多服务')), 1)),
                        (isLogin.value)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 2,
                              class: "vip-history mt-10",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (vipHistoryVisible.value = true))
                            }, _toDisplayString(_unref(t)('会员开通记录')), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", {
                            class: "user-btn",
                            onClick: openVip
                          }, _toDisplayString(_unref(t)('开通会员')), 1)
                        ])
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (_unref(membership).templateLevel > 0)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              class: "member-level-img abs",
                              src: `https://static-s.theckb.com/BusinessMarket/Client/member/member_level_${_unref(membership).templateLevel}.png`,
                              alt: ""
                            }, null, 8, _hoisted_19))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_20, [
                          (_unref(membership)?.trialFlag)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(isSpecial.value ? _unref(t)('特惠体验中') : _unref(t)('试用')), 1))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(_unref(t)('有效期至')) + "：", 1),
                          _createElementVNode("div", null, _toDisplayString(_unref(membership).expiresDate), 1)
                        ]),
                        (isLogin.value)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: "vip-history",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (vipHistoryVisible.value = true))
                            }, _toDisplayString(_unref(t)('会员开通记录')), 1))
                          : _createCommentVNode("", true),
                        (beforehandVipInfo.value?.oldExpiresDate)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 2,
                              class: _normalizeClass(["yuchong-time", _unref(useSite)()])
                            }, _toDisplayString(_unref(dayjs)(beforehandVipInfo.value?.oldExpiresDate).add(1, 'day').format('YYYY-MM-DD')) + " - " + _toDisplayString(_unref(dayjs)(beforehandVipInfo.value?.expiresDate).format('YYYY-MM-DD')) + " " + _toDisplayString(_unref(t)('{member}に変更予定', { member: beforehandVipInfo.value?.membershipTemplateName })), 3))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["flex-ter", [{ textline: isAuto.value === 1 }]])
                          }, [
                            _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(t)('自动续费2')), 1),
                            _createVNode(_component_el_switch, {
                              "model-value": isAuto.value === 1,
                              "inline-prompt": "",
                              "active-text": "ON",
                              "inactive-text": "OFF",
                              onClick: changeSwitch
                            }, null, 8, ["model-value"])
                          ], 2),
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", {
                              class: "user-btn",
                              onClick: renew
                            }, _toDisplayString(_unref(t)('去续费')), 1)
                          ])
                        ])
                      ], 64))
                ]),
                _hoisted_25
              ], 2)
            ], 2))
          : (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(t)('当前等级')), 1),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_29, _toDisplayString(_unref(t)('未登録')), 1),
                  _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(t)('入会优享超多服务')), 1)
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", {
                    class: "user-btn test",
                    onClick: openVip
                  }, _toDisplayString(_unref(t)('开通会员')), 1)
                ])
              ])
            ]))
      ])
    ], 2),
    (__props.isInvitatePage || isSpecial.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            (sepecialConfig.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _createVNode(Recommon, {
                    newSpecialMemberFlag: newSpecialMemberFlag.value,
                    newSpecialMember: newSpecialMember.value,
                    list: sepecialConfig.value
                  }, null, 8, ["newSpecialMemberFlag", "newSpecialMember", "list"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_35, [
              (sepecialRightTb.value.length || sepecialRightTc.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                    _createVNode(VipEquity, {
                      newSpecialMemberFlag: newSpecialMemberFlag.value,
                      newSpecialMember: newSpecialMember.value,
                      tblist: sepecialRightTb.value,
                      tclist: sepecialRightTc.value
                    }, null, 8, ["newSpecialMemberFlag", "newSpecialMember", "tblist", "tclist"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "membership",
                onClick: openVip
              }, [
                (newSpecialMemberFlag.value && newSpecialMember.value.limitedQuantityStatus)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(_unref(t)('名额仅剩X名').replace('X', newSpecialMember.value.lastQuantity)), 1))
                  : _createCommentVNode("", true),
                (newSpecialMemberFlag.value && newSpecialMember.value.trialDiscount === -1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('新人开通专属会员享')), 1),
                      _createElementVNode("span", _hoisted_39, _toDisplayString(_unref(formatMoney)(newSpecialMember.value.trialPrice)), 1),
                      _createElementVNode("span", null, _toDisplayString(_unref(t)('円/首月')), 1),
                      _createElementVNode("span", _hoisted_40, [
                        _createElementVNode("span", _hoisted_41, _toDisplayString(_unref(formatMoney)(newSpecialMember.value.discountActualPrice)), 1),
                        _createElementVNode("span", null, _toDisplayString(_unref(t)('円/月')), 1)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(_unref(t)('立即开通专属会员')), 1))
              ]),
              (invitationCode.value && isSpecial.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "copyLink",
                    onClick: copySpecialLink
                  }, _toDisplayString(_unref(t)('复制专属会员推广链接')), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, _toDisplayString(_unref(t)('专属会员专享服务')), 1),
                _createElementVNode("div", _hoisted_47, _toDisplayString(_unref(t)('如有任何疑问，请用LINE扫描右侧二维码联系我们，获取专属咨询服务。')), 1)
              ]),
              _hoisted_48
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(UpTipsDialog, {
      ref: (_value, _refs) => {
        _refs['UpTipsDialogRef'] = _value
        UpTipsDialogRef.value = _value
      },
      comboList: _unref(comboListShowList),
      onCancel: _cache[2] || (_cache[2] = ($event: any) => (openModal(_unref(renewInfo)))),
      onOk: _cache[3] || (_cache[3] = ($event: any) => (openModal(_unref(level1Info))))
    }, null, 8, ["comboList"]),
    _createVNode(MemberTabs, {
      isSpecial: isSpecial.value,
      openModal: openModal,
      comboList: _unref(comboListShowList),
      memberTab: memberTab.value,
      changeTab: changeTab
    }, null, 8, ["isSpecial", "comboList", "memberTab"]),
    _createVNode(PayConfirm, {
      visible: confirmVisible.value,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((confirmVisible).value = $event)),
      beforehandVipInfo: beforehandVipInfo.value,
      ref: (_value, _refs) => {
        _refs['payConfirmRef'] = _value
        payConfirmRef.value = _value
      },
      onSubmit: submitPay
    }, null, 8, ["visible", "beforehandVipInfo"]),
    _createVNode(PayContent, {
      visible: payVisible.value,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((payVisible).value = $event)),
      ref: (_value, _refs) => {
        _refs['payContentRef'] = _value
        payContentRef.value = _value
      },
      onSuccess: paySuccess,
      onError: errorPay
    }, null, 8, ["visible"]),
    _createVNode(PaySuccessVue, {
      visible: paySuccessVisible.value,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((paySuccessVisible).value = $event)),
      ref: (_value, _refs) => {
        _refs['paySuccessVue'] = _value
        paySuccessVue.value = _value
      },
      onClose: closePaySuccess
    }, null, 8, ["visible"]),
    _createVNode(SetShop, {
      visible: setShopVisible.value,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((setShopVisible).value = $event)),
      vipInfo: vipInfo.value,
      onSubmit: reload
    }, null, 8, ["visible", "vipInfo"]),
    _createVNode(PayError, {
      visible: payErrorVisible.value,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((payErrorVisible).value = $event))
    }, null, 8, ["visible"]),
    _createVNode(ADialog, {
      visible: aDialogVisible.value,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((aDialogVisible).value = $event)),
      onSubmit: closeAutoPay,
      isAuto: isAuto.value,
      onReload: getAutoStatus
    }, null, 8, ["visible", "isAuto"]),
    _createVNode(VipHistory, {
      visible: vipHistoryVisible.value,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((vipHistoryVisible).value = $event))
    }, null, 8, ["visible"]),
    _createVNode(AutoPayDisabled, {
      visible: autoPayDisabledVisible.value,
      "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((autoPayDisabledVisible).value = $event)),
      beforehandVipInfo: beforehandVipInfo.value
    }, null, 8, ["visible", "beforehandVipInfo"]),
    _createVNode(CommonDialog, {
      onCancel: _cache[13] || (_cache[13] = ($event: any) => (openVipVisible.value = false)),
      className: "waring_dialog",
      visible: openVipVisible.value,
      width: 480,
      "append-to-body": ""
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_49, [
          _hoisted_50,
          _createTextVNode(" " + _toDisplayString(_unref(t)('提醒')), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_51, _toDisplayString(_unref(t)('您无法购买该会员，请前往会员中心购买普通会员')), 1),
        _createElementVNode("div", _hoisted_52, [
          _createVNode(_component_el_button, {
            type: "default",
            onClick: _cache[12] || (_cache[12] = ($event: any) => (openVipVisible.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            color: "#008060",
            onClick: openWarinVip,
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('开通会员')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 2))
}
}

})